class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelector('.product-tabs__list');
    this.panels = this.querySelector('.product-tabs__panels');
    this.tabButtons = [];
    this.tabPanels = [];
    this.activeIndex = 0;
    this.init();
  }

  init() {
    if (!this.tabs || !this.panels) return;

    this.tabButtons = Array.from(this.tabs.querySelectorAll('[role="tab"]'));
    this.tabPanels = Array.from(this.panels.querySelectorAll('[role="tabpanel"]'));

    this.tabButtons.forEach((button, index) => {
      button.setAttribute('tabindex', index === 0 ? '0' : '-1');
      button.addEventListener('click', () => this.activateTab(index));
      button.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });

    const initialActive = this.tabButtons.findIndex(btn => btn.getAttribute('aria-selected') === 'true');
    if (initialActive >= 0) {
      this.activeIndex = initialActive;
    }

    this.updateTabs(this.activeIndex);
  }

  activateTab(index) {
    if (index < 0 || index >= this.tabButtons.length) return;
    if (index === this.activeIndex) return;

    this.updateTabs(index);
    this.tabButtons[index].focus();
  }

  updateTabs(index) {
    this.tabButtons.forEach((button, i) => {
      const isActive = i === index;
      button.setAttribute('aria-selected', isActive);
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.tabPanels.forEach((panel, i) => {
      const isActive = i === index;
      panel.setAttribute('aria-hidden', !isActive);
      panel.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.activeIndex = index;
  }

  handleKeydown(event, currentIndex) {
    let newIndex = currentIndex;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        newIndex = currentIndex - 1;
        if (newIndex < 0) newIndex = this.tabButtons.length - 1;
        break;
      case 'ArrowRight':
        event.preventDefault();
        newIndex = currentIndex + 1;
        if (newIndex >= this.tabButtons.length) newIndex = 0;
        break;
      case 'Home':
        event.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        newIndex = this.tabButtons.length - 1;
        break;
      default:
        return;
    }

    this.activateTab(newIndex);
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}